// extracted by mini-css-extract-plugin
export default {"progress":"Progress_progress__tahNx","progress__title":"Progress_progress__title__q7jzg","progress__bar":"Progress_progress__bar__09JrC"};